<template>
<div ref="advance_filter" id="advance_filter" class="modal modal-right fade modal-more-filters" tabindex="-1" role="dialog" aria-labelledby="advance_filter">
    <div class="modal-dialog" role="document" style="width: 360px;">
        <div class="modal-content" ref="section">
            <div class="modal-header bg-dark">
                <h6 class="modal-title">{{$t("More Filters")}}</h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body p-0 pb-5 px-0">

                <div class="card card-collapsed border-0 shadow-none mb-0">
                    <div class="card-header header-elements-inline border-0 shadow-none p-0">
                        <div @click="toggleOption('status')" aria-expanded="false" class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3" data-toggle="collapse" data-target="#collapse-status">
                            <div>{{$t("Order Status")}}</div>
                            <div class="header-elements">
                                <div class="list-icons">
                                    <a :class="['list-icons-item', {'rotate-180': !options.status}]" data-action="collapse"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="collapse ui-filter-list card-body  px-4" id="collapse-status">
                        <div class="filter-option">
                            <div class="form-group" :class="{'mb-0': !statusList.length}">
                                <div class="form-check" v-for="status in statusList" :key=status.id>
                                    <label class="form-check-label">
                                        <div class="uniform-choice">
                                            <span :class="[(dataFilter.status === status.id ? 'checked' : '')]">
                                                <input type="radio" name="adv_status_filter" :id="status.name" :value="status.id" v-model="dataFilter.status">
                                            </span>
                                        </div>
                                        <span>{{$t(status.name)}}</span>
                                    </label>
                                </div>
                            </div>
                            <div class="clear">
                                <a href="javascript:void(0)" class="text-secondary" @click="clearFilter('status')">{{$t("Clear")}}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card card-collapsed border-0 shadow-none mb-0">
                    <div class="card-header header-elements-inline border-0 shadow-none p-0">

                        <div @click="toggleOption('carrier')" aria-expanded="false" class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3" data-toggle="collapse" data-target="#collapse-carrier">
                            <div>{{$t("Carrier")}}</div>
                            <div class="header-elements">
                                <div class="list-icons">
                                    <a :class="['list-icons-item', {'rotate-180': !options.carrier}]" data-action="collapse"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="collapse ui-filter-list card-body  px-4" id="collapse-carrier">
                        <div class="filter-option">
                            <div class="form-group" :class="{'mb-0': !carrierList.length}">
                                <div class="form-check" v-for="carrier in carrierList" :key=carrier.id>
                                    <label class="form-check-label">
                                        <div class="uniform-checker">
                                            <span :class="[(dataFilter.carrier.includes(carrier.id) ? 'checked' : '')]">
                                                <input type="checkbox" class="custom-control-input" :value="carrier.id" :id="'advance_carrier-'+carrier.id" v-model="dataFilter.carrier" @change="filterChange()">
                                            </span>
                                        </div>
                                        <img :src="carrier.integration_type.logo" class="mr-2 rounded" width="20">
                                        {{ $t(carrier.name) }}
                                    </label>
                                </div>
                            </div>
                            <div class="clear">
                                <a href="javascript:void(0)" class="text-secondary" @click="clearFilter('carrier')">{{$t("Clear")}}</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card card-collapsed border-0 shadow-none mb-0">
                    <div class="card-header header-elements-inline border-0 shadow-none p-0">
                        <div @click="toggleOption('payment_method')" aria-expanded="false" class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3" data-toggle="collapse" data-target="#collapse-payment_method">
                            <div>{{$t("Payment Methods")}}</div>
                            <div class="header-elements">
                                <div class="list-icons">
                                    <a :class="['list-icons-item', {'rotate-180': !options.payment_method}]" data-action="collapse"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="collapse ui-filter-list card-body  px-4" id="collapse-payment_method">
                        <div class="filter-option">
                            <div class="form-group" :class="{'mb-0': !datainfo.payment_method.length}">
                                <div class="form-check" v-for="payment in datainfo.payment_method" :key="payment.id">
                                    <label class="form-check-label">
                                        <div class="uniform-checker">
                                            <span :class="[(dataFilter.payment_method.includes(payment.id) ? 'checked' : '')]">
                                                <input type="checkbox" class="custom-control-input" :value="payment.id" :id="'pay-'+payment.id" v-model="dataFilter.payment_method" @change="filterChange()">
                                            </span>
                                        </div>
                                        {{$t(payment.name)}}
                                    </label>
                                </div>
                            </div>
                            <div class="clear">
                                <a href="javascript:void(0)" class="text-secondary" @click="clearFilter('payment_method')">{{$t("Clear")}}</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card card-collapsed border-0 shadow-none mb-0">
                    <div class="card-header header-elements-inline border-0 shadow-none p-0">
                        <div @click="toggleOption('payment_status')" aria-expanded="false" class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3" data-toggle="collapse" data-target="#collapse-payment_status">
                            <div>{{$t("Payment Status")}}</div>
                            <div class="header-elements">
                                <div class="list-icons">
                                    <a :class="['list-icons-item', {'rotate-180': !options.payment_status}]" data-action="collapse"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="collapse ui-filter-list card-body  px-4" id="collapse-payment_status">
                        <div class="filter-option">
                            <div class="form-group" :class="{'mb-0': !datainfo.payment_status.length}">
                                <div class="form-check" v-for="payment in datainfo.payment_status" :key="payment.id">
                                    <label class="form-check-label">
                                        <div class="uniform-checker">
                                            <span :class="[(dataFilter.payment_status.includes(payment.id) ? 'checked' : '')]">
                                                <input type="checkbox" class="custom-control-input" :value="payment.id" :id="'pay-'+payment.id" v-model="dataFilter.payment_status" @change="filterChange()">
                                            </span>
                                        </div>
                                        {{$t(payment.name)}}
                                    </label>
                                </div>
                            </div>
                            <div class="clear">
                                <a href="javascript:void(0)" class="text-secondary" @click="clearFilter('payment_status')">{{$t("Clear")}}</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card card-collapsed border-0 shadow-none mb-0">
                    <div class="card-header header-elements-inline border-0 shadow-none p-0">
                        <div @click="toggleOption('channels')" aria-expanded="false" class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3" data-toggle="collapse" data-target="#collapse-channels">
                            <div>{{$t("Channels")}}</div>
                            <div class="header-elements">
                                <div class="list-icons">
                                    <a :class="['list-icons-item', {'rotate-180': !options.channels}]" data-action="collapse"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="collapse ui-filter-list card-body  px-4" id="collapse-channels">
                        <div class="filter-option">
                            <div class="form-group" :class="{'mb-0': !datainfo.channels.length}">
                                <div class="form-check" v-for="channels in datainfo.channels" :key="channels.id">
                                    <label class="form-check-label">
                                        <div class="uniform-checker ">
                                            <span :class="[(dataFilter.channels.includes(channels.id) ? 'checked' : '')]">
                                                <input type="checkbox" class="custom-control-input" :value="channels.id" :id="'pay-'+channels.id" v-model="dataFilter.channels" @change="filterChange()">
                                            </span>
                                        </div>
                                        <img :src="channels.integration_type.logo" class="mr-2 rounded" width="20">
                                        {{$t(channels.name)}}
                                    </label>
                                </div>
                            </div>
                            <div class="clear">
                                <a href="javascript:void(0)" class="text-secondary" @click="clearFilter('channels')">{{$t("Clear")}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer fixed-bottom bg-light border-top d-flex justify-content-between py-2 px-3">
                <button type="button" class="btn btn-light" @click="clearFilter('all')">{{$t('Clear all filters')}}</button>
                <button type="button" class="btn btn-primary" @click="doneFilter()" data-dismiss="modal">{{$t('Done')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/services/endpoint/tenant.service'
import DateRangePicker from 'vue2-daterange-picker'
import moment from "moment";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Axios from 'axios';

export default {
    name: "advance_filter",
    components: {
        DateRangePicker,
        moment
    },
    // props: [
    //     "carrierList",
    //     "statusList",
    // ],
    props: ["filter", "carrierList", "statusList", "status", "carrier", "payment_method", "payment_status", "channels", "dateRange"],
    data() {
        return {
            options: {
                status: false,
                carrier: false,
                payment_method: false,
                payment_status: false,
                channels: false,
                date: false,
            },
            dataFilter: initialFilter(),
            datainfo: {
                payment_method: [],
                payment_status: [{
                        'id': '0',
                        'name': this.$t('_Payment.Pending'),
                    },
                    {
                        'id': '1',
                        'name': this.$t('Partial Paid'),
                    },
                    {
                        'id': '2',
                        'name': this.$t('Paid'),
                    },
                    {
                        'id': '3',
                        'name': this.$t('Confirmed'),
                    }
                ],
                channels: [],
                date: {
                    singleDatePicker: 'range',
                    opens: 'right',
                    ranges: true,
                    appendtobody: true,
                    autoApply: true,
                    localedata: {
                        format: 'dd/mm/yyyy',
                    }
                }
            }
        }
    },
    async mounted() {
        this.getPayment();
        this.getChannels();
        $(this.$refs.advance_filter).on('shown.bs.modal', () => {
        });
    },
    computed: {
        showTextPicker: function () {
            if (this.dataFilter.dateRange.startDate && this.dataFilter.dateRange.endDate) {
                return moment(this.dataFilter.dateRange.startDate).utc().format('DD/MM/YYYY') + ' - ' + moment(this.dataFilter.dateRange.endDate).utc().format('DD/MM/YYYY');
            } else {
                return this.$t("Order Date...");
            }
        }
    },
    methods: {
        toggleOption(key) {
            if (key == 'status') {
                (this.options.status) ? this.options.status = false: this.options.status = true;
            } else if (key == 'carrier') {
                (this.options.carrier) ? this.options.carrier = false: this.options.carrier = true;
            } else if (key == 'payment_method') {
                (this.options.payment_method) ? this.options.payment_method = false: this.options.payment_method = true;
            } else if (key == 'payment_status') {
                (this.options.payment_status) ? this.options.payment_status = false: this.options.payment_status = true;
            } else if (key == 'channels') {
                (this.options.channels) ? this.options.channels = false: this.options.channels = true;
            } else if (key == 'date') {
                (this.options.date) ? this.options.date = false: this.options.date = true;
            }
        },
        clearFilter(key) {
            
        },
        async getPayment(){
          let data = await Api.PaymentMethod.getPaymentMethod()
          this.datainfo.payment_method = data.data.data;
          this.$emit('payment_method', data.data.data);
        },
        async getChannels(){
          let data = await Api.Integration.getIntegration('?integration_group_id=1')
          this.datainfo.channels = data.data.data;
          this.$emit('channel', data.data.data);
        },
        filterChange() {
        },
        doneFilter() {
            this.$parent.countFilter = this.dataFilter.status.length + this.dataFilter.carrier.length + this.dataFilter.payment_method.length + this.dataFilter.payment_status.length + this.dataFilter.channels.length;
            this.$parent.filterinfo(this.dataFilter);
        }
    }
}

function initialFilter() {
    return {
        status: [],
        carrier: [],
        payment_method: [],
        payment_status: [],
        channels: [],
        dateRange: {
            startDate: null,
            endDate: null,
        },
    }
}

</script>

<style>
/* .daterangepicker.single.show-ranges .drp-calendar.left {
    border-left: 0;
}

.daterangepicker.opensright .calendars {
    width: 100%;
}

.calendars-container {
    width: 100%;
}

.drp-calendar.col.left.single {
    width: 100%;
    max-width: 100%;
}

.daterangepicker.ltr.show-calendar.show-ranges.single.opensright.linked {
    left: 0;
}

@media screen and (min-width: 339px) {

    .daterangepicker.single.show-ranges.show-weeknumbers ,
    .daterangepicker.single.show-ranges  {
        min-width: 100%;
    }
} */
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/settings/sale/sale-contact/AdvanceFilter.vue